import { render, staticRenderFns } from "./CreateAllRightRequest.vue?vue&type=template&id=90d0ac1e&scoped=true&"
import script from "./CreateAllRightRequest.vue?vue&type=script&lang=js&"
export * from "./CreateAllRightRequest.vue?vue&type=script&lang=js&"
import style0 from "./CreateAllRightRequest.vue?vue&type=style&index=0&id=90d0ac1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d0ac1e",
  null
  
)

export default component.exports